import React from 'react';
import { useImpersonation } from '../contexts/ImpersonationContext';

const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, tenantName, stopImpersonation } = useImpersonation();

  if (!isImpersonating || !tenantName) {
    return null;
  }

  return (
    <div className="sticky top-0 z-50 w-full bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-between shadow-md">
      <span className="font-medium">
        You are impersonating Tenant: {tenantName}
      </span>
      <button
        onClick={stopImpersonation}
        className="ml-4 px-4 py-1.5 rounded-md bg-amber-700 text-white font-medium hover:bg-amber-800 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-offset-1 focus:ring-offset-amber-500 transition-colors"
      >
        Stop Impersonating
      </button>
    </div>
  );
};

export default ImpersonationBanner;
